import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@/lib/utils';

/**
 * Slider de Radix. Soporta uno o varios tiradores: se dibuja un tirador por
 * cada valor de `value`/`defaultValue`, así el mismo componente sirve para un
 * valor suelto o para un rango.
 *
 * `etiquetasDeLosTiradores`: el nombre de cada tirador para un lector de
 * pantalla («Cambio, desde», «Cambio, hasta»). Sin él, Radix los llama
 * «Minimum» y «Maximum».
 */
const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    etiquetasDeLosTiradores?: string[];
  }
>(({ className, etiquetasDeLosTiradores, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn('relative flex w-full touch-none select-none items-center', className)}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-muted">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
    </SliderPrimitive.Track>
    {(props.value ?? props.defaultValue ?? []).map((_, i) => (
      <SliderPrimitive.Thumb
        key={i}
        aria-label={etiquetasDeLosTiradores?.[i]}
        className="block h-4 w-4 rounded-full border border-primary/50 bg-campo shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
      />
    ))}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
